export const GET_REQUEST_TRANSLATION = 'GET_REQUEST_TRANSLATION'
export const GET_REQUEST_TRANSLATION_SUCCESS = 'GET_REQUEST_TRANSLATION_SUCCESS'
export const GET_REQUEST_TRANSLATION_ERROR = 'GET_REQUEST_TRANSLATION_ERROR'

export const GET_FACULTIES = 'GET_FACULTIES'
export const GET_FACULTIES_SUCCESS = 'GET_FACULTIES_SUCCESS'
export const GET_FACULTIES_ERROR = 'GET_FACULTIES_ERROR'

export const GET_LANGUAGES = 'GET_LANGUAGES'
export const GET_LANGUAGES_SUCCESS = 'GET_LANGUAGES_SUCCESS'
export const GET_LANGUAGES_ERROR = 'GET_LANGUAGES_ERROR'

export const GET_PAYMENT_METHODS = 'GET_PAYMENT_METHODS'
export const GET_PAYMENT_METHODS_SUCCESS = 'GET_PAYMENT_METHODS_SUCCESS'
export const GET_PAYMENT_METHODS_ERROR = 'GET_PAYMENT_METHODS_ERROR'

export const GET_PROVIDERS = 'GET_PROVIDERS'
export const GET_PROVIDERS_SUCCESS = 'GET_PROVIDERS_SUCCESS'
export const GET_PROVIDERS_ERROR = 'GET_PROVIDERS_ERROR'

export const GET_CUSTOMERS = 'GET_CUSTOMERS'
export const GET_CUSTOMERS_SUCCESS = 'GET_CUSTOMERS_SUCCESS'
export const GET_CUSTOMERS_ERROR = 'GET_CUSTOMERS_ERROR'

export const GET_ROLES = 'GET_ROLES'
export const GET_ROLES_SUCCESS = 'GET_ROLES_SUCCESS'
export const GET_ROLES_ERROR = 'GET_ROLES_ERROR'

export const EDIT_REQUEST = 'EDIT_REQUEST'
export const EDIT_REQUEST_SUCCESS = 'EDIT_REQUEST_SUCCESS'
export const EDIT_REQUEST_ERROR = 'EDIT_REQUEST_ERROR'

export const DELETE_USER = 'DELETE_USER'
export const DELETE_USER_SUCCESS = 'DELETE_USER_SUCCESS'
export const DELETE_USER_ERROR = 'DELETE_USER_ERROR'

export const ADD_CUSTOMER = 'ADD_CUSTOMER'
export const ADD_CUSTOMER_SUCCESS = 'ADD_CUSTOMER_SUCCESS'
export const ADD_CUSTOMER_ERROR = 'ADD_CUSTOMER_ERROR'

export const EDIT_CUSTOMER = 'EDIT_CUSTOMER'
export const EDIT_CUSTOMER_SUCCESS = 'EDIT_CUSTOMER_SUCCESS'
export const EDIT_CUSTOMER_ERROR = 'EDIT_CUSTOMER_ERROR'

export const ADD_PROVIDER = 'ADD_PROVIDER'
export const ADD_PROVIDER_SUCCESS = 'ADD_PROVIDER_SUCCESS'
export const ADD_PROVIDER_ERROR = 'ADD_PROVIDER_ERROR'

export const EDIT_PROVIDER = 'EDIT_PROVIDER'
export const EDIT_PROVIDER_SUCCESS = 'EDIT_PROVIDER_SUCCESS'
export const EDIT_PROVIDER_ERROR = 'EDIT_PROVIDER_ERROR'